import { Box, Typography, Chip, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Lesson } from "./ArticleReader";

interface LessonInfoProps {
  lesson: Lesson;
  lessonNumber: number;
  nextLesson: Lesson | null;
  onNext: () => void;
}

const getContentTypeLabel = (type: string) => {
  switch (type) {
    case "video":
      return "Video";
    case "audio":
      return "Audiobook";
    case "article":
      return "Reading";
    default:
      return "Content";
  }
};

export default function LessonInfo({
  lesson,
  lessonNumber,
  nextLesson,
  onNext,
}: LessonInfoProps) {
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "40px",
        p: 3,
        mt: 3,
      }}
    >
      {/* Lesson Tags */}
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <Chip
          label={`Lesson ${lessonNumber}`}
          sx={{
            bgcolor: "#f0e6dc",
            color: "#724E41",
            fontWeight: 500,
            fontSize: "0.85rem",
          }}
        />
        <Chip
          label={getContentTypeLabel(lesson.content_type)}
          sx={{
            bgcolor: "#F1F5F9",
            color: "#475569",
            fontWeight: 500,
            fontSize: "0.85rem",
          }}
        />
      </Box>

      {/* Lesson Title */}
      <Typography sx={{ fontSize: "1.5rem", fontWeight: 600, mb: 1 }}>
        {lesson.title}
      </Typography>

      {/* Lesson Duration */}
      <Typography sx={{ fontSize: "0.95rem", color: "#666", mb: 3 }}>
        {lesson.duration}
      </Typography>

      {/* Divider */}
      <Box sx={{ borderTop: "1px solid #e0e0e0", pt: 3 }}>
        {/* Up Next Section */}
        {nextLesson && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "0.85rem", color: "#666", mb: 0.5 }}>
                Up Next
              </Typography>
              <Typography sx={{ fontSize: "1rem", fontWeight: 500 }}>
                {nextLesson.title}
              </Typography>
            </Box>

            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              onClick={onNext}
              sx={{
                color: "#D8947B",
                borderColor: "#D8947B",
                textTransform: "none",
                fontWeight: 500,
                px: 3,
                py: 1,
                borderRadius: 40,
                "&:hover": {
                  borderColor: "#c49563",
                  bgcolor: "#fef9f4",
                },
              }}
            >
              Next
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
